import { render, staticRenderFns } from "./SubMenuTable.vue?vue&type=template&id=30e642bf&scoped=true"
import script from "./SubMenuTable.vue?vue&type=script&lang=js"
export * from "./SubMenuTable.vue?vue&type=script&lang=js"
import style0 from "./SubMenuTable.vue?vue&type=style&index=0&id=30e642bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e642bf",
  null
  
)

export default component.exports